import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterSettingConfig} from '../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../components/Table/Table'
import {Selection} from 'src/components/Selection'
import {DatePickerV2} from 'src/components'

// eslint-disable-next-line react/display-name
export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterSettingConfig: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterSettingConfig({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('RowFilter.Feature')}
          value={filter?.label ?? ''}
          onChange={({target}) => handleFilterChange({label: target.value})}
        />
      </td>
      <td>
        <Selection
          data={[
            {value: 'true', label: 'Active'},
            {value: 'false', label: 'Inactive'},
          ]}
          placeholder={t('Status')}
          value={filter?.status ?? ''}
          onChange={(target) => handleFilterChange({status: target})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('RowFilter.Date')}
          startDate={filter?.updated_at ?? ''}
          isSelectsRange={false}
          onChange={({startDate, endDate}) => handleFilterChange({updated_at: startDate})}
        />
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TRowFilter>
  )
})
